<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="element-box">
        <CoachingOverviewData :coaching="coachingData" :calculatedUnits="calculatedUnitsData"/>
        <Menu :coaching="coachingData"
              :currentUser="piniaCurrentUser"/>

        <div class="row text-right">
          <div class="col-12">
            <button type="button" class="btn btn-primary" @click="handleProtocolModalForm">Protokoll hinzufügen
            </button>
            <button type="button" class="btn btn-outline-primary" @click="handleNoteModalForm">Zwischennotiz
            </button>
          </div>
        </div>

        <div class="table-responsive overflow-auto mt-5">
          <table class="table table-striped table-hover">
            <thead>
            <tr>
              <th style="font-size: 12px;">Termin</th>
              <th style="font-size: 12px;">Startzeit</th>
              <th style="font-size: 12px;">Endzeit</th>
              <th style="font-size: 12px;">Anwesenheit</th>
              <th style="font-size: 12px;">Zusammenfassende Dokumentation ...</th>
              <th class="text-right" style="font-size: 12px;">Einheiten</th>
              <th class="text-center" style="font-size: 12px;">Unterschrift</th>
              <th style="font-size: 12px;">Coachart</th>
              <th style="font-size: 12px;">Coach</th>
              <th style="font-size: 12px;">Beschreibung</th>
              <th style="font-size: 12px;" v-if="currentUserRole === 'ROLE_ADMIN'"></th>
              <th :style="isDigitalSignature
                    ? 'min-width:200px; text-align: right; font-size: 12px; padding-right: 50px;'
                    : 'min-width:100px; text-align: right; font-size: 12px; padding-right: 50px;'">
                Aktion
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="protocol in protocolList"
                :key="protocol.id"
                :class="['table-row', { 'bg-light-gray': protocol.note }]"
                @click="handleClickOnEdit(protocol)">
              <template v-if="!protocol.note">
                <th scope="row">{{ protocol?.termin }}</th>
                <td>{{ protocol?.startTime }}</td>
                <td>{{ protocol?.endTime }}</td>
                <td>{{ protocol?.presenceTranslation }}</td>
                <td>{{ truncate(protocol?.meetingTopic, 30) }}</td>
                <td class="text-right">{{ protocol?.units }}</td>
                <td class="text-center">
                  <template v-if="protocol.assistedLivingCoaching.digitalSignature">
                    <template v-if="!protocol.digitalSignatureImage">
                      <span style="color: #cf1020">
                        Fehlende Digitale Unterschrift
                      </span>
                    </template>
                    <template v-else>
                      JA
                    </template>
                  </template>
                  <template v-else>
                    <template v-if="protocol.signature">
                      JA
                    </template>
                    <template v-else>
                      NEIN
                    </template>
                  </template>
                </td>
                <td>
                  <strong class="js-lists-values-employee-name">
                    <span v-if="protocol?.coachType === 'specialist' ">
                        Fachkraft
                    </span>
                    <span v-if="protocol?.coachType === 'supervisor' ">
                        Assisstenzkraft
                    </span>
                  </strong>
                </td>
                <td>{{ protocol?.coach?.fullName }}</td>
                <td>{{ truncate(protocol?.description, 60) }}</td>
              </template>
              <template v-else>
                <th scope="row">{{ protocol?.termin }}</th>
                <td colspan="9">
                  {{ protocol?.createdByUserData?.fullName }}
                  <span style="margin: 0 15px;">|</span>
                  {{ truncate(protocol?.description, 180) }}
                </td>
              </template>

              <td class="text-center" v-if="currentUserRole === 'ROLE_ADMIN'">
                <button class="btn btn-primary"
                        v-if="protocol.updatedByAdmin"
                        @click.stop="handleMeetingHistoryModal(protocol?.id)">
                  <i class="os-icon os-icon-rotate-ccw"></i>
                </button>
              </td>

              <td class="text-center">
                <div v-if="showButtons(protocol)" class="d-flex justify-content-end">
                  <div v-if="showDigitalSignatureButton(protocol, isDigitalSignature)"
                       style="margin-right: 15px; width: max-content">
                    <button class="btn btn-primary" @click.stop="handleDigitalSignatureModal(protocol?.id)">
                      Digitale Unterschrift
                    </button>
                  </div>
                  <div v-if="showDigitalSignatureButton(protocol, isDigitalSignature, true)"
                       style="margin-right: 15px; width: max-content">
                    <div class="btn-group dropleft" @click.stop="showDropdown = showDropdown === protocol.id ? null : protocol.id">
                      <button type="button" class="btn btn-primary"
                              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Gruppenunterschrift
                      </button>
                      <div class="dropdown-menu" :class="showDropdown === protocol.id ? 'show': ''">
                        <button class="dropdown-item" @click.stop="handleGroupDigitalSignatureModal(
                            protocol?.id,
                            parentMeetingData.coachingId,
                            parentMeetingData.coachingName
                        )">
                          {{ parentMeetingData.coachingName }}
                        </button>

                        <div v-for="appointment in protocol.groupAppointments" :key="appointment.coachingId">
                          <button class="dropdown-item" @click.stop="handleGroupDigitalSignatureModal(
                              appointment.protocolId,
                              appointment.coachingId,
                              appointment.coachingName
                              )">
                            {{ appointment.coachingName }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="showDeleteButton(protocol)"
                       style="width: 40px;">
                    <button class="btn btn-danger" @click.stop="handleDeleteModal(protocol?.id)">
                      <i class="os-icon os-icon-trash"></i>
                    </button>
                  </div>
                  <div v-else style="float: right">
                    <div style="width: 40px"></div>
                  </div>
                </div>
                <div v-else>
                  Gruppenangebot
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <Modal
          v-model="showProtocolModalForm"
          title="Protokoll"
          :hide-cancel="true"
          :button-label="$t('general.button.save')"
          :customWidth="'1400px'"
          :hide-footer="true"
          classFooter="justify-content-center">
        <Form :protocolId="protocolId"
              :locationId="locationId"
              :coachingId="coachingId"
              :operationType="operationType"
              :isDigitalSignature="coachingData?.requiresSignature"
              v-model:submitForm="submitForm"/>
      </Modal>

      <Modal
          v-model="showNoteModalForm"
          title="Zwischennotiz"
          :hide-cancel="true"
          :button-label="$t('general.button.save')"
          sizeModal="modal-xl"
          :hide-footer="true"
          classFooter="justify-content-center">
        <NoteForm :protocolId="protocolId"
                  :coachingId="coachingId"
                  v-model:submitForm="submitForm"/>
      </Modal>

      <Modal
          v-model="showDigitalSignatureModal"
          title="Digitale Unterschrift"
          :hide-cancel="true"
          sizeModal="modal-md"
          :hide-footer="true"
          classFooter="justify-content-center">
        <AssistedLivingCoachingDigitalSignatureForm
            :meetingId="protocolId"
            :coachingId="coachingId"
            meetingType="protocol"
            v-model:submitForm="submitForm"/>
      </Modal>

      <Modal
          v-model="showGroupDigitalSignatureModal"
          :title="groupDigitalSignatureCoachingName"
          :hide-cancel="true"
          sizeModal="modal-md"
          :hide-footer="true"
          classFooter="justify-content-center">
        <AssistedLivingCoachingDigitalSignatureForm
            :meetingId="groupAppointmentId"
            :coachingId="groupAppointmentCoachingId"
            meetingType="protocol"
            v-model:submitForm="submitForm"/>
      </Modal>

      <ModalDelete
          v-model="showDeleteModal"
          :header="t('general.delete_item_header')"
          :onDelete="deleteProtocol">
      </ModalDelete>

      <Modal
          title="Begegnungsgeschichte"
          :button-label="$t('general.button.save')"
          :customWidth="'1400px'"
          v-model="showMeetingHistoryModal"
          :hide-footer="true"
          classFooter="justify-content-center">
        <MeetingHistoryList :meetingId="protocolId"/>
      </Modal>
    </div>
  </PageTemplate>
</template>

<script setup>
import portalAssistedLivingCoachingService from '@/api/Portal/AssistedLivingCoaching';
import assistedLivingCoachingService from '@/api/Unemployed/AssistedLivingCoaching';
import Loader from '@/components/Loader.vue';
import Modal from '@/components/modal/Modal.vue';
import ModalDelete from '@/components/modal/ModalDelete.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import {piniaUserStore} from '@/store/piniaUserStore';
import AssistedLivingCoachingDigitalSignatureForm
  from '@/views/App/Portal/AssistedLivingCoaching/AssistedLivingCoachingDigitalSignatureForm.vue';
import CoachingOverviewData from '@/views/App/Portal/AssistedLivingCoaching/CoachingOverviewData.vue';
import Menu from '@/views/App/Portal/AssistedLivingCoaching/Menu.vue';
import Form from '@/views/App/Portal/AssistedLivingCoaching/Protocol/Form.vue';
import NoteForm from '@/views/App/Portal/AssistedLivingCoaching/Protocol/NoteForm.vue';
import {computed, onMounted, ref, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import {useRoute} from 'vue-router';
import MeetingHistoryList from "@/views/App/Portal/AssistedLivingCoaching/MeetingHistoryList.vue";

const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const currentUserRole = piniaCurrentUser?.value?.roles[0];
const {t} = useI18n();
const route = useRoute();
const coachingData = ref('');
const operationType = ref('');
const protocolId = ref('');
const locationId = ref('')
const protocolList = ref([]);
const calculatedUnitsData = ref();
const coachingId = +route.params.id;
const isLoaded = ref(false);
const isDigitalSignature = ref(false);
const showProtocolModalForm = ref(false);
const showNoteModalForm = ref(false);
const showDeleteModal = ref(false);
const showDigitalSignatureModal = ref(false);
const submitForm = ref(false);
const showDropdown = ref(null);
const showMeetingHistoryModal = ref(false);

// For group appointments
const parentMeetingData = ref({})
const groupAppointmentId = ref('')
const groupAppointmentCoachingId = ref('')
const showGroupDigitalSignatureModal = ref(false);
const groupDigitalSignatureCoachingName = ref("")

watch(submitForm, () => {
  protocolId.value = null;
  showDigitalSignatureModal.value = false;
  showGroupDigitalSignatureModal.value = false
  showProtocolModalForm.value = false;
  showProtocolModalForm.value = false;
  showNoteModalForm.value = false;
  showDeleteModal.value = false;
  showDropdown.value = null;
  getCoachingData();
  getProtocolList();
});

async function getProtocolList() {
  try {
    const {data} = await portalAssistedLivingCoachingService.getProtocolList(coachingId);
    protocolList.value = data.data;
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getCoachingData() {
  try {
    CloseToast();
    const {data} = await assistedLivingCoachingService.getAssistedLivingCoaching(+coachingId);
    coachingData.value = data.data;
    operationType.value = coachingData.value?.nameOfCoaching?.operationType;
    isDigitalSignature.value = coachingData.value?.digitalSignature;
    locationId.value = coachingData.value?.unemployed.location.id

    const {data: calculatedUnits} = await assistedLivingCoachingService.getCalculatedUnits(+coachingId);
    calculatedUnitsData.value = calculatedUnits.data;

    const coachingName = coachingData.value?.unemployed.firstName + " " + coachingData.value?.unemployed.lastName

    parentMeetingData.value = {
      coachingId: coachingId,
      coachingName: coachingName
    }
  } catch (error) {
    await ErrorToast(error);
  }
}

function handleClickOnEdit(protocol) {
  CloseToast();
  if (protocol.note) {
    handleEditNoteModalForm(protocol.id);
  } else {
    handleEditProtocolModalForm(protocol.id);
  }
}

function handleProtocolModalForm() {
  CloseToast();
  showDropdown.value = null;
  protocolId.value = '';
  showProtocolModalForm.value = true;
  showNoteModalForm.value = false;
  showDeleteModal.value = false;
  showGroupDigitalSignatureModal.value = false;
  groupDigitalSignatureCoachingName.value = '';
  showMeetingHistoryModal.value = false;
}

function handleEditProtocolModalForm(id) {
  CloseToast();
  showDropdown.value = null;
  protocolId.value = id;
  showProtocolModalForm.value = true;
  showNoteModalForm.value = false;
  showDeleteModal.value = false;
  showGroupDigitalSignatureModal.value = false;
  groupDigitalSignatureCoachingName.value = '';
  showMeetingHistoryModal.value = false;
}

function handleNoteModalForm() {
  CloseToast();
  showDropdown.value = null;
  protocolId.value = '';
  showNoteModalForm.value = true;
  showProtocolModalForm.value = false;
  showDeleteModal.value = false;
  showGroupDigitalSignatureModal.value = false;
  groupDigitalSignatureCoachingName.value = '';
  showMeetingHistoryModal.value = false;
}

function handleEditNoteModalForm(id) {
  CloseToast();
  showDropdown.value = null;
  protocolId.value = id;
  showNoteModalForm.value = true;
  showProtocolModalForm.value = false;
  showDeleteModal.value = false;
  showGroupDigitalSignatureModal.value = false;
  groupDigitalSignatureCoachingName.value = '';
  showMeetingHistoryModal.value = false;
}

function handleDeleteModal(id) {
  CloseToast();
  showDropdown.value = null;
  protocolId.value = id;
  showDeleteModal.value = true;
  showProtocolModalForm.value = false;
  showNoteModalForm.value = false;
  showGroupDigitalSignatureModal.value = false;
  groupDigitalSignatureCoachingName.value = '';
  showMeetingHistoryModal.value = false;
}

function handleDigitalSignatureModal(id) {
  CloseToast();
  showDropdown.value = null;
  protocolId.value = id;
  showDigitalSignatureModal.value = true;
  showDeleteModal.value = false;
  showProtocolModalForm.value = false;
  showNoteModalForm.value = false;
  showGroupDigitalSignatureModal.value = false;
  groupDigitalSignatureCoachingName.value = '';
  showMeetingHistoryModal.value = false;
}

function handleGroupDigitalSignatureModal(id, coachingId, coachingName) {
  CloseToast();
  showDropdown.value = null;
  groupAppointmentId.value = id;
  groupAppointmentCoachingId.value = coachingId;
  groupDigitalSignatureCoachingName.value = coachingName;
  showGroupDigitalSignatureModal.value = true;
  showDigitalSignatureModal.value = false;
  showDeleteModal.value = false;
  showProtocolModalForm.value = false;
  showNoteModalForm.value = false;
  showMeetingHistoryModal.value = false;
}

function handleMeetingHistoryModal(id) {
  CloseToast();
  protocolId.value = id;
  showMeetingHistoryModal.value = true;
  showDigitalSignatureModal.value = false;
  showDeleteModal.value = false;
  showProtocolModalForm.value = false;
  showNoteModalForm.value = false;
}

function showButtons(protocol) {
  return protocol.parentMeetingId == null
}

function showDigitalSignatureButton(protocol, isDigitalSignature, group = false) {
  return !protocol.note
      && isDigitalSignature
      && protocol.parentMeetingId == null
      && ((group && protocol.appointmentType === 'group') || (!group && protocol.appointmentType !== 'group'));
}

function showDeleteButton(protocol) {
  return currentUserRole === 'ROLE_ADMIN' ||
      (!protocol.invoiced && !protocol.coachInvoiced && protocol.parentMeetingId == null);
}

const truncate = (text, length) => {
  if (!text || typeof text !== 'string') {
    return ''; // Return an empty string if text is null, undefined, or not a string
  }

  const strippedText = text.replace(/<\/?[^>]+(>|$)/g, ''); // Remove HTML tags
  return strippedText.length > length ? strippedText.substring(0, length) + '...' : strippedText;
};

async function deleteProtocol() {
  try {
    await portalAssistedLivingCoachingService.protocolDelete(protocolId.value);

    protocolId.value = null;
    showDeleteModal.value = false;

    await getCoachingData();
    await getProtocolList();
    SuccessToast(t('general.toasts.delete_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  CloseToast();
  await Promise.all([
    getCoachingData(),
    getProtocolList(),
  ]);
  isLoaded.value = true;
});
</script>

<style scoped>

</style>